// Star Path: the Starflower of Destiny marks every step on the path (home banner → Know the signs → the guides → …).
export const STARFLOWER_LOGO = "https://customer-assets.emergentagent.com/job_211279cf-e69f-4285-b28c-6209ba7e3f92/artifacts/mi6oafuj_starflower-star-of-destiny-logo-png_orig%202.png";

export const StarPathMark = ({ className = "h-6 w-6" }) => (
  <img src={STARFLOWER_LOGO} alt="" className={`${className} rounded-full object-cover ring-1 ring-white/50 shrink-0`} data-testid="star-path-mark" />
);
